import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import * as DescarteActions from '../../tabs/descarte/store/descarte.action';
import * as MateriaisActions from '../../tabs/materiais/store/materiais.action';
import * as RelatoriosActions from '../../tabs/relatorios/store/relatorios.action';
import Row from 'reactstrap/lib/Row';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../helpers/intlMessage';
import SelectComponent from '@componentes/select/select.component';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';
import { useIntl } from 'react-intl';

function InputString(props) {
  const dispatch = useDispatch();
  const [type, setType] = useState('text');
  const [isFocus, setIsFocus] = useState(true);

  function onKeyPressInput(event) {
    if (event.key === 'Enter' && props.onPressEnter) {
      props.onPressEnter();
    }
  }

  const descateDataInicio = useSelector(state => state.descarteMaterial.dataInicio);
  const descarteDataFim = useSelector(state => state.descarteMaterial.dataFim);
  const descarteFiltroValue = useSelector(state => state.descarteMaterial.filtroValue);
  const materiaisDataInicio = useSelector(state => state.materiaisDescartados.dataInicio);
  const materiaisDataFim = useSelector(state => state.materiaisDescartados.dataFim);
  const materiaisFiltroValue = useSelector(state => state.materiaisDescartados.filtroValue);
  const relatorioDataInicio = useSelector(state => state.descarteRelatorios.dataInicio);
  const relatorioDataFim = useSelector(state => state.descarteRelatorios.dataFim);
  const relatorioFiltroValue = useSelector(state => state.descarteRelatorios.filtroValue);

  function changeInput(tipo) {
    if (props.tab === '1' || props.tab === 0) {
      if (tipo === 'dtini') {
        return descateDataInicio;
      } else if (tipo === 'dtfim') {
        return descarteDataFim;
      } else {
        return descarteFiltroValue;
      }
    } else if (props.tab === '2') {
      if (tipo === 'dtini') {
        return materiaisDataInicio;
      } else if (tipo === 'dtfim') {
        return materiaisDataFim;
      } else {
        return materiaisFiltroValue;
      }
    } else if (props.tab === '3') {
      if (tipo === 'dtini') {
        return relatorioDataInicio;
      } else if (tipo === 'dtfim') {
        return relatorioDataFim;
      } else {
        return relatorioFiltroValue;
      }
    }
  }

  function montAction(tipo, val) {
    if (props.tab === '1' || props.tab === 0) {
      if (tipo === 'dtini') {
        return dispatch(DescarteActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(DescarteActions.dataFim(val));
      } else {
        return dispatch(DescarteActions.filtroValue(val));
      }
    } else if (props.tab === '2') {
      if (tipo === 'dtini') {
        return dispatch(MateriaisActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(MateriaisActions.dataFim(val));
      } else {
        return dispatch(MateriaisActions.filtroValue(val));
      }
    } else if (props.tab === '3') {
      if (tipo === 'dtini') {
        return dispatch(RelatoriosActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(RelatoriosActions.dataFim(val));
      } else {
        return dispatch(RelatoriosActions.filtroValue(val));
      }
    }
  }

  function validaInput(el) {
    if (props.component === 'peso') {
      if (Number(el) <= 0) {
        montAction('', 0);
      } else {
        montAction('', Number(el));
      }
    } else if (props.component === 'items') {
      if (Number(el) <= 0) {
        montAction('', '');
      } else {
        montAction('', Number(el));
      }
    } else if (props.component === 'diasavencer') {
      const value = changeInput();
      if (Number(el) > 0 && Number(el) < 90) {
        montAction('', (el.toString()));
      } else if (props.component === 1 && el === '') {
        montAction('', '');
      } else {
        montAction('', value);
      }
    } else {
      montAction('', el);
    }
  }

  useEffect(() => {
    switch (props.valida) {
      case 'peso':
      case 'items':
      case 'diasavencer':
        setType('number');
        break;

      default:
        break;
    }

  }, [props.component]);

  return (
    <div className={`nome-${props.component}`}>
      <Input
        id={props.component}
        name={props.component}
        value={changeInput()}
        autoFocus={isFocus}
        onBlur={() => setIsFocus(false)}
        onClick={() => setIsFocus(true)}
        type={type}
        onChange={(e) => {
          const el = e.target.value;
          validaInput(el);
        }}
        onKeyPress={onKeyPressInput}
      />
    </div>
  );
}

function DTPeriodoInicioFim(props) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const descateDataInicio = useSelector(state => state.descarteMaterial.dataInicio);
  const descarteDataFim = useSelector(state => state.descarteMaterial.dataFim);
  const descarteFiltroValue = useSelector(state => state.descarteMaterial.filtroValue);
  const materiaisDataInicio = useSelector(state => state.materiaisDescartados.dataInicio);
  const materiaisDataFim = useSelector(state => state.materiaisDescartados.dataFim);
  const materiaisFiltroValue = useSelector(state => state.materiaisDescartados.filtroValue);
  const relatorioDataInicio = useSelector(state => state.descarteRelatorios.dataInicio);
  const relatorioDataFim = useSelector(state => state.descarteRelatorios.dataFim);
  const relatorioFiltroValue = useSelector(state => state.descarteRelatorios.filtroValue);
  const periodo = useSelector(state => state.descarteMaterial.tipoPeriodo);
  const periodos = obterListagemDePeriodos(intl);

  function resetarPeriodo() {
    dispatch(DescarteActions.tipoPeriodo(''));
    montAction('dtini', null);
    montAction('dtfim', null);
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    dispatch(DescarteActions.tipoPeriodo(e));
    montAction('dtini', payload.dtinicial);
    montAction('dtfim', payload.dtfinal);
	}

  function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    montAction('dtini', payload.start);
    montAction('dtfim', payload.end);
	}

  function montAction(tipo, val) {
    if (props.tab === '1' || props.tab === 0) {
      if (tipo === 'dtini') {
        return dispatch(DescarteActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(DescarteActions.dataFim(val));
      } else {
        return dispatch(DescarteActions.filtroValue(val));
      }
    } else if (props.tab === '2') {
      if (tipo === 'dtini') {
        return dispatch(MateriaisActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(MateriaisActions.dataFim(val));
      } else {
        return dispatch(MateriaisActions.filtroValue(val));
      }
    } else if (props.tab === '3') {
      if (tipo === 'dtini') {
        return dispatch(RelatoriosActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(RelatoriosActions.dataFim(val));
      } else {
        return dispatch(RelatoriosActions.filtroValue(val));
      }
    }
  }

  function changeInicio(e) {
    let date = e.target.value;
    montAction('dtini', date);
  }

  function changeFim(e) {
    let date = e.target.value;
    montAction('dtfim', date);
  }

  function changeInput(tipo) {
    if (props.tab === '1' || props.tab === 0) {
      if (tipo === 'dtini') {
        return descateDataInicio;
      } else if (tipo === 'dtfim') {
        return descarteDataFim;
      } else {
        return descarteFiltroValue;
      }
    } else if (props.tab === '2') {
      if (tipo === 'dtini') {
        return materiaisDataInicio;
      } else if (tipo === 'dtfim') {
        return materiaisDataFim;
      } else {
        return materiaisFiltroValue;
      }
    } else if (props.tab === '3') {
      if (tipo === 'dtini') {
        return relatorioDataInicio;
      } else if (tipo === 'dtfim') {
        return relatorioDataFim;
      } else {
        return relatorioFiltroValue;
      }
    }
  }

  function onKeyPressInput(event) {
    if (event.key === 'Enter' && props.onPressEnter) {
      props.onPressEnter();
    }
  }

  return (
    <React.Fragment>
      <Row>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
          <div className="label-data"><IntlMessage id="period.name"/></div>
          <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
            <SelectComponent
              isClearable
              className="filtro-data"
              noOptionsMessage={() => {return <IntlMessage id="dashboards.reports.noItemsFound"/>}}
              name="form-field-period"
              placeholder={<IntlMessage id="dashboards.general.selectPeriod"/>}
              value={periodo}
              onChange={(e) => {
                periodoAlterado(e);
                e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
              }}
              options={periodos}
            />
          </div>

          {periodo && periodo.value === 'outro' && (
            <React.Fragment>
              <DebounceInput
                name="periodoDe"
                type="date"
                style={{width: '130px', display: 'block'}}
                className="filtro-data"
                value={changeInput('dtini')}
                onChange={(e) => {changeInicio(e)}}
                onKeyPress={(e) => onKeyPressInput(e)}
              />
              <DebounceInput
                name="periodoAte"
                type="date"
                style={{width: '130px', display: 'block'}}
                className="filtro-data"
                value={changeInput('dtfim')}
                onChange={(e) => {changeFim(e)}}
                onKeyPress={(e) => onKeyPressInput(e)}
              />
            </React.Fragment>
          )}
        </div>
      </Row>
    </React.Fragment>
  );
}

export default function ComponentesDescarte({ component, onPressEnter }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const tab = useSelector(state => state.descarteCommon.tab);

  function resetInput() {
    dispatch(DescarteActions.filtroValue(''));

    let tipoPeriodo = { value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` };
    dispatch(DescarteActions.tipoPeriodo(tipoPeriodo));
  }

  useEffect(() => {
    obterPeriodos();
    resetInput();
  }, []);

  function montAction(tipo, val) {
    if (tab === '1' || tab === 0) {
      if (tipo === 'dtini') {
        return dispatch(DescarteActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(DescarteActions.dataFim(val));
      } else {
        return dispatch(DescarteActions.filtroValue(val));
      }
    } else if (tab === '2') {
      if (tipo === 'dtini') {
        return dispatch(MateriaisActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(MateriaisActions.dataFim(val));
      } else {
        return dispatch(MateriaisActions.filtroValue(val));
      }
    } else if (tab === '3') {
      if (tipo === 'dtini') {
        return dispatch(RelatoriosActions.dataInicio(val));
      } else if (tipo === 'dtfim') {
        return dispatch(RelatoriosActions.dataFim(val));
      } else {
        return dispatch(RelatoriosActions.filtroValue(val));
      }
    }
  }

  function obterPeriodos() {
    const periodos = CommonFunctions.getPeriodosSubDays(0);
    montAction('dtini', periodos.periodoInicial);
    montAction('dtfim', periodos.periodoFinal);
  }

  const CustomComponent = (component) => {

    if (component.includes('dt')) {
      return <DTPeriodoInicioFim tab={tab} onPressEnter={onPressEnter} />
    } else if (
      component === 'idfrasco' ||
      component === 'descricao' ||
      component === 'nrExame' ||
      component === 'paciente' ||
      component === 'usuario'
    ) {
      return <InputString component={component} tab={tab} onPressEnter={onPressEnter} />
    } else if (
      component === 'peso'
    ) {
      return <InputString component={component} valida='peso' tab={tab} onPressEnter={onPressEnter} />
    } else if (
      component === 'items' || component === ' nrPedido'
    ) {
      return <InputString component={component} valida='items' tab={tab} onPressEnter={onPressEnter} />
    } else if (
      component === 'diasavencer'
    ) {
      return <InputString component={component} valida='diasavencer' tab={tab} onPressEnter={onPressEnter} />
    } else {
      return <div></div>
    }

  }

  return CustomComponent(component)
}



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/index.js